// Масштаб миниатюр: рост человека до макушки — 40 мм (config/print_profiles.yaml), другие
// расы — доля от него.
import type { CatalogRace } from "../api/types";

export const HUMAN_HEIGHT_MM = 40;

export function raceHeightMm(race: Pick<CatalogRace, "height_share">): number {
  return Math.round(HUMAN_HEIGHT_MM * race.height_share);
}
